import React, { useState } from "react";

function CustomerApp_process() {
  const [formData, setFormData] = useState({
    country: "",
    university: "",
    course: "",
    appliedBy: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  return (
    <div className="p-6 bg-white rounded-lg shadow-md  max-w-6xl mx-auto">
      {/* Title */}
      <h2 className="text-2xl font-semibold mb-4">Application Process</h2>
      <p className="text-sm text-gray-600 mb-4">
        You can add universities for the client. Please note that additional
        2000 will be added in the invoice for each university after 10
        universities!
      </p>

      {/* Form */}
      <div className="grid grid-cols-3 gap-6 mb-4">
        {/* Country Dropdown */}
        <div>
          <label htmlFor="country" className="block text-sm text-gray-600 mb-2">
            Country
          </label>
          <select
            name="country"
            value={formData.country}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
          >
            <option value="">Nothing selected</option>
            <option value="USA">USA</option>
            <option value="UK">UK</option>
            <option value="Canada">Canada</option>
            {/* Add more countries here */}
          </select>
        </div>

        {/* University Dropdown */}
        <div>
          <label
            htmlFor="university"
            className="block text-sm text-gray-600 mb-2"
          >
            University
          </label>
          <select
            name="university"
            value={formData.university}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
          >
            <option value="">Nothing selected</option>
            <option value="Harvard">Harvard University</option>
            <option value="MIT">MIT</option>
            <option value="Oxford">Oxford University</option>
            {/* Add more universities here */}
          </select>
        </div>

        {/* Course Dropdown */}
        <div>
          <label htmlFor="course" className="block text-sm text-gray-600 mb-2">
            Course
          </label>
          <select
            name="course"
            value={formData.course}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
          >
            <option value="">Nothing selected</option>
            <option value="MBA">MBA</option>
            <option value="MSc">MSc</option>
            <option value="PhD">PhD</option>
            {/* Add more courses here */}
          </select>
        </div>

        {/* Applied By */}
        <div>
          <label
            htmlFor="appliedBy"
            className="block text-sm text-gray-600 mb-2"
          >
            Applied By
          </label>
          <input
            type="text"
            name="appliedBy"
            value={formData.appliedBy}
            onChange={handleChange}
            className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-purple-600"
          />
        </div>
      </div>

      {/* Save Button */}
      <div className="flex justify-end mb-6">
        <button className="bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700">
          Save
        </button>
      </div>

      {/* Message */}
      <p className="text-sm text-gray-500">
        No universities found in the database for this client!!!
      </p>
    </div>
  );
}

export default CustomerApp_process;
